
window.addEventListener('DOMContentLoaded', function() {

(function(c,l,a,r,i,t,y){
    c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
    t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
    y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
})(window, document, "clarity", "script", "uilzalcnui");

function loadScript() {
  // <!-- Nextop LiveChat {literal} -->
    (function(d,w,c){w.NextopLiveChatID='LIVECHAT:1758792152404:809861634988527616';w[c]=w[c]||function(){(w[c].q=w[c].q||[]).push(arguments)};var s=d.createElement('script');s.async=true;s.src='https://livechat.nextop.com/nextop-im-sdk.min.js';if(d.head)d.head.appendChild(s)})(document,window,'NextopLiveChat');
  // <!-- / Nextop LiveChat {/literal} -->
  window.removeEventListener('scroll', loadScript);
}
window.addEventListener('scroll', loadScript);

})